'use es6';

import { LEAD_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Lead = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (isUngated, hasScope) => isUngated('LeadTracking:GeneralAccess') && hasScope('leads-read'),
  objectTypeId: LEAD_TYPE_ID,
  referenceObjectType: 'LEAD_PROPERTIES'
});
export default Lead;